<app-sub-nav title="Users" i18n-title="@@companyUsers" queryParamKey="usersTab">
	<ng-template appSubNavTab label="All Users" i18n-label="@@userMainTab-allLabel" automationId="company-all-users-tab">
		<app-user-directory
			[companyId]="companyId"
			[company]="company"
			[embeddedInCompanyDetail]="true"
			[appBreadcrumbLabel]="breadcrumbLabel"
		></app-user-directory>
	</ng-template>

	@if (canSeeWhitelistTab && !canSeeWhitelistUsers) {
		<ng-template
			appSubNavTab
			label="Whitelist"
			i18n-label="@@userMainTab-whitelist"
			automationId="company-whitelist-tab"
		>
			<app-user-whitelist
				[companyId]="companyId"
				[allowMutate]="allowWhitelistMutate"
				[appBreadcrumbLabel]="breadcrumbLabel"
				(whitelistPageSelectionChanged)="onWhitelistPageSelectionChanged($event)"
			></app-user-whitelist>
		</ng-template>
	}

	@if (canSeeWhitelistTab && canSeeWhitelistUsers) {
		<ng-template
			appSubNavTab
			label="Whitelist"
			i18n-label="@@userMainTab-whitelistUsers"
			automationId="company-whitelist-users-tab"
		>
			<app-user-directory
				[companyId]="companyId"
				[company]="company"
				[embeddedInCompanyDetail]="true"
				[showWhitelistedUsers]="true"
				[appBreadcrumbLabel]="breadcrumbLabel"
				(whitelistPageSelectionChanged)="onWhitelistPageSelectionChanged($event)"
			></app-user-directory>
		</ng-template>
	}
</app-sub-nav>
